import Header from "./components/Header";
import Hero from "./components/Hero";
import SearchLookup from "./components/SearchLookup";
import EventsSection from "./components/EventsSection";
import PeopleSection from "./components/PeopleSection";
import HotComments from "./components/HotComments";
import TrendingRank from "./components/TrendingRank";
import MoreGrid from "./components/MoreGrid";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <SearchLookup />
        <EventsSection />
        <PeopleSection />
        <HotComments />
        <TrendingRank />
        <MoreGrid />
      </main>
      <Footer />
    </div>
  );
}